import * as types from './mutation-types';
import { defaultServiceState } from './state';

export default {
  [types.RESET_SERVICE](state) {
    Object.assign(state.service, defaultServiceState());
  },
  [types.SET_SUMMARY_SERVICES](state, payload) {
    state.summaryServices = payload;
  },
  [types.SET_PAGINATION_SERVICE](state, payload) {
    state.paginationService = payload;
  },
  [types.SET_DETAILED_SERVICE](state, payload) {
    state.service = payload;
  },
  [types.SET_SERVICE_COLLECTION](state, payload) {
    state.serviceCollection = payload;
  },
  [types.SET_SERVICES_WARNINGS](state, payload) {
    state.warnings = payload;
  },
};
